import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const params = new URLSearchParams(
            window.location.hash.replace(/^#/, ""),
        );
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        fetch(`${API}/auth/session`, {
            headers: { "X-Session-ID": sessionId },
            credentials: "include",
        })
            .then(async (res) => {
                if (!res.ok) throw new Error("session exchange failed");
                const data = await res.json();
                navigate("/admin", {
                    replace: true,
                    state: { user: data.user },
                });
            })
            .catch(() => {
                navigate("/login", { replace: true });
            });
    }, [navigate]);

    return (
        <div className="auth-callback" data-testid="auth-callback">
            <div className="auth-callback-inner">
                Signing you in…
            </div>
        </div>
    );
}
